import React from 'react';
import { Icon } from './Icon.js';
export const IconPhotoFilled = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m14,2H6c-2.206,0-4,1.794-4,4v8c0,2.206,1.794,4,4,4h8c2.206,0,4-1.794,4-4V6c0-2.206-1.794-4-4-4Zm-7.25,3.5c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25-1.25-.56-1.25-1.25.56-1.25,1.25-1.25Zm7.25,10.5H6c-.688,0-1.296-.349-1.656-.88l5.888-5.888c.943-.944,2.591-.944,3.536,0l2.232,2.232v2.536c0,1.103-.897,2-2,2Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconPhotoFilled.js.map